import React from "react";
import { useLocation } from "react-router-dom";
import ViewVendorDetail from "../Vendor/viewVendorDetail";
import useDecryptData from "../../../utils/DecryptData";

const EmpViewVendorDetail = () => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const vendorId = search.get("vendorId");
  const decryptData = useDecryptData();

  let mode = "view";
  const encryptedMode = search.get("mode");
  if (encryptedMode) {
    try {
      mode = decryptData(decodeURIComponent(encryptedMode)) || "view";
    } catch {
      mode = "view";
    }
  }

  return <ViewVendorDetail vendorId={vendorId} routedMode={mode} />;
};

export default EmpViewVendorDetail;
